<template>
	<div>
		<div id="webHeader">
			<headerShow :headerTxt="'车型对比('+carAll.length+')'" isButtonShow="false"></headerShow>
		</div>
		<section class="parameter-detail fn-mt">
			<header id="compareHeader" :class="[{'sticky':isShowFixedTabTxT}]"><!--class="sticky"-->
				<div>
					<section class="compare">
			          <div class="left">
			            <label @click="hiddenSame"><span>隐藏相同</span></label>
			          </div>
			          <div class="main"  style="touch-action: pan-y pinch-zoom;">
			            <div class="slide" id="scroller__compare" style="transform: translate(0px, 0px) translateZ(0px);">
			            	<div v-for="(item,index) in carAll" class="column">
								<h4>
									{{item.carInfo.name}}
									<i v-if="carAll.length>1" @click="deleteCar(index)" class="iconfont icon-shutter reduce">&times;</i>
								</h4>
							</div>
			       		</div>
			          </div>
		        	</section>
		            <section class="markbar">
		            	<strong v-text="fixedTabTxT"></strong>
		            	<span class="markup">
		            		<em><i class="iconcss"></i>标配</em>
		            		<em><i class="iconcss"></i>选配</em>
		            		<em><i class="iconcss"></i>无</em>
		            	</span>
		            </section>
				</div>
	            
	        </header>
	        <section id="header-stand" class="header-stand" v-show="isShowFixedTabTxT"></section>
	        <section id="detail-stand" class="detail">
	        	<div id="scroller__left" class="left">
	        		<div v-for="(item,index) in carAllafter" class="group">
        				<h4 v-show="index!=0" v-if="isShowSame || item.differ">
							<strong>
								{{item.title}}
							</strong>
							<span class="markup">
								<em>
									<i class="iconcss">
									</i>
									标配
								</em>
								<em>
									<i class="iconcss">
									</i>
									选配
								</em>
								<em>
									<i class="iconcss">
									</i>
									无
								</em>
							</span>
						</h4>
						<div v-show="isShowSame || itemInIn.differ" v-for="(itemInIn,indexInIn) in item.carInforList" :class="['item',{'same':!itemInIn.differ}]" v-if="indexInIn!=1">
							<span class="inner">
								{{itemInIn.title}}
							</span>
						</div>
	        		</div>
	        	</div>
	        	<div class="main" id="scroller__main"  style="touch-action: pan-y pinch-zoom; ">
             		<div class="slide" id="scroller__detail" style="transform: translate(0px, 0px) translateZ(0px);">
               			<div id="scroller__data" class="data">
               				<div v-for="(item,index) in carAllafter" class="group">
								<div v-if="(isShowSame || itemIn.differ) && indexIn!=1" v-for="(itemIn,indexIn) in item.carInforList"  :class="['clearfix','item',{'same':!itemIn.differ}]">
									<span v-if="itemIn.type==1">
										<span v-for="(itemInIn,indexInIn) in itemIn.value"  class="inner" style="line-height: 0;">
											<span class="car-color" v-for="(cItem,idx) in filt(itemInIn)" v-if=" idx<11":key="idx" :style="{'background': cItem.value}"></span>
										</span>
									</span>
									<span v-else>
										<span v-for="(itemInIn,indexInIn) in itemIn.value" class="inner">
											{{itemInIn}}
										</span>
									</span>
								</div>
               				</div>	
               			</div>
               		</div>
               	</div>
	        </section>

		</section>
		<div @click.stop="IsShowMemuContent()" class="menu">
			<div class="menu-tag"><em></em>目录</div>
			<div  v-show="memuContentIsShow" class="memu-content">
				<em class="memu-content-arror"></em>
				<ul id="memu-content-list" class="clearfix memu-content-list">
					<li @click.stop="scrollWinTag(index)" v-for="(item,index) in carAllafter">
						{{item.title}}
					</li>
				</ul>
			</div>
		</div>
	</div>
</template>
<style scoped lang="less">
.car-color{
	display: inline-block;
	margin: 0.14rem 0.2rem;
	width: 0.2rem;
    height: 0.2rem;
}
</style>
<script>
	import { Toast } from 'mint-ui';
	import headerShow from "@/components/comparison/header.vue"
	export default {
		name: 'comparison',
		data:function() {
			return {
				//表格头文件是否跟随
				isHeaderFixed:false,
				//是否展示相同项
				isShowSame:true,
				//记录当前滚动距离
				scrollParams:{
					winScrollTop:0,
					tagOffsetTop:[],
				},
				//存储滑动到Title
				fixedTabTxT:"",
				//是否fixed头部
				isShowFixedTabTxT:false,
				//是否展示menu
				memuContentIsShow:false,
				//基础数据
				carAll:[
					// {
					// 	carInfo:{
					// 		id:0,
					// 		name:"宝来2019款 1.5L 手自一体 时尚版",
					// 		logo:"http://pic.tuanche.com/car/20151012/14446420934155159_o.jpg",
					// 		price:"20.12万－27.12万"
					// 	},
					// 	paramlist:[
					// 		{
					// 			title:"基本参数",

					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价	1",
					// 					value:"12.5万1"
					// 				},
					// 				{
					// 					title:"厂商指导价2",
					// 					value:"12.5万2"
					// 				},
					// 				{
					// 					title:"厂商指导价3",
					// 					value:"12.5万3",
					// 					type:"special"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数1",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价4",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价5",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价6",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数2",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数3",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数4",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数5",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数4",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数5",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		}
					// 	]
					// },
					// {
					// 	carInfo:{
					// 		id:0,
					// 		name:"宝来2019款 1.5L 手自一体 时尚版",
					// 		logo:"http://pic.tuanche.com/car/20151012/14446420934155159_o.jpg",
					// 		price:"20.12万－27.12万"
					// 	},
					// 	paramlist:[
					// 		{
					// 			title:"基本参数",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万1"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万2"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万3",
					// 					type:"special"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数1",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数2",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数3",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数4",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数5",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数4",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数5",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		}
					// 	]
					// },
					// {
					// 	carInfo:{
					// 		id:0,
					// 		name:"宝来2019款 1.5L 手自一体 时尚版",
					// 		logo:"http://pic.tuanche.com/car/20151012/14446420934155159_o.jpg",
					// 		price:"20.12万－27.12万"
					// 	},
					// 	paramlist:[
					// 		{
					// 			title:"基本参数",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万",
					// 					type:"special"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数1",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数2",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数3",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数4",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数5",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数4",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		},
					// 		{
					// 			title:"基本参数5",
					// 			carInfoList:[
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				},
					// 				{
					// 					title:"厂商指导价",
					// 					value:"12.5万"
					// 				}
					// 			]
					// 		}
					// 	]
					// }
				],
				carAllafter:[],
				curtransX:0
			}
		},
		components:{
			headerShow
		},
		mounted: function() {
			var self = this;
			getCommonJsIns.initCSSNEW();
			getCommonJsIns.initSingleCSSNEW({
				cssURL: "/css/mapply/comparison/parameter.css?v=3s3333ddssdh2"
			});
			//确保重要依赖的js加载完成
			getCommonJsIns.initJSNEW(this.webReady);
			/***统计添加**/
			! function(e, t, n, g, i) {
				e[i] = e[i] || function() {
					(e[i].q = e[i].q || []).push(arguments)
				};
				var n = t.createElement("script");
				var tag = t.getElementsByTagName("script")[0];
				n.async = 1;
				n.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + g;
				tag.parentNode.insertBefore(n, tag);
			}(window, document, "script", "assets.growingio.com/2.1/gio.js", "gio");
			gio('init', '8004d11f5708cccc', {});
			//custom page code begin here
			//custom page code end here
			gio('send');
			gio('enableHT', 'true');
			/***统计添加**/
			
			//点击任意地方关闭目录
			document.getElementById("detail-stand").onclick = function(event){
				self.memuContentIsShow = false;
			}	
		},
		// updated:function(){
			

		// },
		methods: {
			webReady:function(){
				var self = this;
				this.initWeb();	
			},
			filt:function(item){
				if(item!=''){
					return JSON.parse(item);
				}
			},
			initWeb:function(){
				var self = this;
				self.ajaxSubmit.ajax({
					url:self.commmonWebConfig.tuancheapi + self.ajaxSubmit.allUrl.comparisonList,
					type:"get",
					data:{
						carIds:self.$route.query.carIds
					},
					success:function(data){
						if(data.responseHeader.status == 200){
							self.carAll = data.response.result;
							//格式化数据
							self.formatData();
							setTimeout(function(){
								self.wetherScroll();
								self.getTagOffsetTop();
								self.getHeaderHeight();
								
								//页面滚动触发 绑定头部
								window.onscroll = function(){
									self.fixedHeader();
								}	
								console.log(self.carAll);
							},100)
						}
					},
					error:function(){}
				})
			},
			getHeaderHeight:function(){
				var headerHeight = document.getElementById("compareHeader").offsetHeight;
				console.log(headerHeight);
				document.getElementById("header-stand").style.height = headerHeight+"px";
			},
			//绑定头部
			fixedHeader:function(){
				this.scrollParams.winScrollTop = $(window).scrollTop();
				//console.log(this.scrollParams.tagOffsetTop);
				for(var i in this.scrollParams.tagOffsetTop){
					if(this.scrollParams.tagOffsetTop[i] > this.scrollParams.winScrollTop){
						if(i==0){
							this.fixedTabTxT = this.carAllafter[i].title;
						}else{
							this.fixedTabTxT = this.carAllafter[i-1].title;
						}
						break;
					}
				}
				if((this.scrollParams.winScrollTop - document.getElementById("webHeader").offsetHeight)>0){
					this.isShowFixedTabTxT = true;
				}else{
					this.isShowFixedTabTxT = false;
				}
			},
			//记录所有便签距离页面顶部的距离
			getTagOffsetTop:function(){
				var oCarInfoContent = document.getElementById("scroller__left");
				var oCarInfoContentDl = oCarInfoContent.getElementsByTagName("h4");
				for(var i = 0; i < oCarInfoContentDl.length ; i++){
					this.scrollParams.tagOffsetTop.push(oCarInfoContentDl[i].offsetTop);
				}
			},
			//左右滑动绑定
			wetherScroll:function(){
				var self = this;
				var startX = 0 , startY = 0 , endX = 0 , endY =0;
				var omain = document.getElementById("scroller__main")
			    var detail=document.getElementById("scroller__detail");
			    var header = document.getElementById("scroller__compare");
			    document.getElementById("scroller__data").style.width = header.offsetWidth+"px";
			    var detailWidth = detail.offsetWidth;
			    var omainWidth = omain.offsetWidth;
			    var transX = 0;
			    detail.ontouchstart = function(event){
			      var touch = event.targetTouches[0];
			      var reg = detail.style.transform.match(/translate\((.*?)\)/);
				  var res = reg && reg[1].split(' ');// [20,20]
				  transX = parseFloat(res[0]);
			      //滑动起点的坐标
			      startX = touch.pageX;
			      startY = touch.pageY;
			      // console.log("startX:"+startX+","+"startY:"+startY);
			    };
			    detail.ontouchmove = function(event){
			      var touch = event.targetTouches[0];
			      //手势滑动时，手势坐标不断变化，取最后一点的坐标为最终的终点坐标
			        endX = touch.pageX;
			        endY = touch.pageY;
			        // console.log("endX:"+endX+","+"endY:"+endY);
			        var distanceX=endX-startX,
			        distanceY=endY - startY;
			         //console.log("distanceX:"+distanceX+","+"distanceY:"+distanceY);
			        //移动端设备的屏幕宽度
			        var clientHeight=document.documentElement.clientHeight;
			        // console.log(clientHeight;*0.2);
			        //判断是否滑动了，而不是屏幕上单击了
			        if(startY!=Math.abs(distanceY)){
			        	//console.log(detail.style.transform);
			        	this.curtransX = distanceX + transX;
			        	console.log(detailWidth);
			        	//if(curtransX < 0 && curtransX > (omainWidth-detailWidth)){

			        		detail.style.transform = "translate("+(distanceX+transX)+"px,0)";
			        		header.style.transform = "translate("+(distanceX+transX)+"px,0)";
			        	//}
			        	
			        }
			    };
			    detail.ontouchend =function(){
			    	if(this.curtransX > 0){
			    		detail.style.transform = "translate(0,0)";
			        	header.style.transform = "translate(0,0)";
			    	}else if(this.curtransX < (omainWidth-detailWidth)){
			    		detail.style.transform = "translate("+(omainWidth-detailWidth)+"px,0)";
			        	header.style.transform = "translate("+(omainWidth-detailWidth)+"px,0)";
			    	}
			    	if(this.curtransX < (omainWidth-detailWidth)){
			    		detail.style.transform = "translate("+(omainWidth-detailWidth)+"px,0)";
			        	header.style.transform = "translate("+(omainWidth-detailWidth)+"px,0)";
			    	}
			    }
			},
			//数据格式化
			formatData:function(){
				var self = this;
				for(var j in this.carAll[0].paramlist){
					this.$set(this.carAllafter,j,{});
					this.carAllafter[j].carInforList = [];
					this.carAllafter[j].title = this.carAll[0].paramlist[j].title;
					for(var k in this.carAll[0].paramlist[j].carInfoList){
						this.carAllafter[j].carInforList[k] = {};
						this.carAllafter[j].carInforList[k].value = [];
						this.carAllafter[j].carInforList[k].title = this.carAll[0].paramlist[j].carInfoList[k].title;
					}
				}
				for(var o in this.carAll){
					for(var p in this.carAll[o].paramlist){
						for(var q in this.carAll[o].paramlist[p].carInfoList){
							var curItem = this.carAll[o].paramlist[p].carInfoList[q];
							if(typeof(curItem.schema) != "undefined" && curItem.schema == "radio"){
								var type = parseInt(curItem.value);
								switch(type){
									case 0:
									self.$set(this.carAll[o].paramlist[p].carInfoList[q],"value","-");
									break;
									case 1:
									self.$set(this.carAll[o].paramlist[p].carInfoList[q],"value","●");
									break;
									case 2:
									self.$set(this.carAll[o].paramlist[p].carInfoList[q],"value","○");
									break;
								}
							}
							this.carAllafter[p].carInforList[q].value.push(this.carAll[o].paramlist[p].carInfoList[q].value);
						}
					}
				}
				
				//标注重复项
				for(var u in this.carAllafter){
					for(var n in this.carAllafter[u].carInforList){
						for(var m=0;m < this.carAllafter[u].carInforList[n].value.length;m++){
							if(this.carAllafter[u].carInforList[n].value.length > 1 ){
								if( m < (this.carAllafter[u].carInforList[n].value.length-1)){
									//console.log(this.carAllafter[u].carInforList[n].value[m] != this.carAllafter[u].carInforList[n].value[m+1])
									if(this.carAllafter[u].carInforList[n].value[m] != this.carAllafter[u].carInforList[n].value[m+1]){
										this.carAllafter[u].carInforList[n].differ = true;
										break; 
									}else{
										this.carAllafter[u].carInforList[n].differ = false;
									}
								}
							}else{
								this.carAllafter[u].carInforList[n].differ = false;
							}
						}
						if(u==14){
							this.$set(this.carAllafter[u].carInforList[n], "type", 1);
						}else{
							this.$set(this.carAllafter[u].carInforList[n], "type", 0);
						}
					}
					console.log( this.carAllafter);
				}

				this.fixedTabTxT = this.carAllafter[0].title;
				var listIsDifferNum = 0;
				for(var r in this.carAllafter){
					listIsDifferNum = 0;
					for(var v in this.carAllafter[r].carInforList){
						if(!this.carAllafter[r].carInforList[v].differ){
							listIsDifferNum += 1;
						}
					}
					if(listIsDifferNum == this.carAllafter[r].carInforList.length){
						this.carAllafter[r].differ = false;
					}else{
						this.carAllafter[r].differ = true;
					}
				}
			},
			IsShowMemuContent:function(){
				this.memuContentIsShow = true;
			},
			//页面按照点击滚动到锚点
			scrollWinTag:function(index){
				this.memuContentIsShow = false;
				$(window).scrollTop(this.scrollParams.tagOffsetTop[index]);
			},
			deleteCar:function(index){
				this.carAll.splice(index,1);
				this.formatData();
				//console.log(this.carAll);
			},
			hiddenSame:function(){
				if(this.carAll.length > 1){
					this.isShowSame = !this.isShowSame
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/views/comparison/parameter.vue